import {
    ApiHandler,
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { getDealers } from "@insite/client-framework/Services/DealerService";
import { DealerCollectionModel, WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import { getCustomDealers, GetCustomDealersApiParameter } from "@NA/Overrides/Services/DealerService";
import { getInventory, InventoryParams, WarehouseModal } from "@NA/Services/ADIGetInventory";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface InventoryParam {
    productId?: string;
}

type HandlerType = CustomApiHandler<InventoryParams & HasOnSuccess & HasOnError, WarehouseModal>;

export const DispatchBeginLoadDealers: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadInventory",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    const { productId } = props.apiParameter;
    props.apiResult = await getInventory({ productId });
};

export const DispatchCompleteLoadDealers: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/CompleteInventory",
            warehouseResult: props.apiResult,
        });
    }
};

export const chain = [DispatchBeginLoadDealers, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadDealers];

const customLoadInventory = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        productId: "",
        onSuccess: (result) => { }
    },
    "customLoadInventory",
);
export default customLoadInventory;